const { compressToEncodedURIComponent, decompressFromEncodedURIComponent } = require('lz-string')

/**
 * @description: 跳转新页面
 * @param {object} url/页面链接
 * @param {object} extraParams/链接上携带的压缩json参数，需解压接收（较复杂的json参数或有url非法字符可用）
 * @param {object} params/链接上直接携带的参数 
 * @return {*}
 */
export const jump = ({ url, extraParams, params, target }: { url: string, extraParams?: Record<string, any>, params?: Record<string, any>, target?: string }) => {
    const searchParams = new URLSearchParams();
    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
            }
        });
    }
    if (extraParams) {
        const str = compressToEncodedURIComponent(JSON.stringify(extraParams))
        searchParams.append('extraParams', str);
    }
    const searchStr = searchParams.toString();
    const fullPath = searchStr ? `${url}?${searchStr}` : url;
    console.log({ url, fullPath, searchStr, params });
    window.open(fullPath, target || '_blank');
}

/**
 * @description: 获取链接上的压缩json参数
 * @return {*}
 */
export const getExtraParams = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const extraParams = params.get('extraParams');
    if (extraParams) {
        try {
            return JSON.parse(decompressFromEncodedURIComponent(extraParams));
        } catch (error) {
            console.error(error);
        }
    }
    return {};
}

/**
 * @description: 获取页面参数
 * @return {*}
 */
export const getParams = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const obj: Record<string, any> = {};
    params.forEach((value, key) => {
        obj[key] = value;
    });
    // 压缩的json参数
    const extraParams = params.get('extraParams');
    if (extraParams) {
        try {
            Object.assign(obj, JSON.parse(decompressFromEncodedURIComponent(extraParams)));
        } catch (error) {
            console.error(error);
        }
    }
    return obj;
}